import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Segment } from 'semantic-ui-react';
import { withRouterWorkaround } from 'utils/workaroundUtils';
import styled from 'styled-components';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import { RouterProps } from 'react-router';
import { BillPaymentSearchResponse, ImportAutomaticPaymentResponse } from 'ts-types/api.types';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import AutomaticPaymentTableView from 'components/payment/automatic/AutomaticPaymentTableView';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';

const StyledAutomaticPaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledAutomaticPayment = styled(Segment)`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;

  &.ui.segment {
    margin-top: 0;
  }
`;

const StyledError = styled.div`
  margin: 0 0 1.2rem;
`;

interface Props extends MessageSourceProps, RouterProps, PatientConsumerRenderProps {
}

interface State {
  billsKey: number,
  bills: Array<BillPaymentSearchResponse>,
  billsLoading: boolean,
  errorCode?: string
}

class AutomaticPaymentView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      billsKey: 1,
      bills: [],
      billsLoading: false,
      errorCode: undefined
    }
  }

  onFilterBills = (importResponse: ImportAutomaticPaymentResponse) => {
    this.setState({
      bills: importResponse.bills,
      errorCode: importResponse.errorCode
    })
  };

  onBillsLoadingChange = (billsLoading: boolean) => {
    this.setState({
      billsLoading: billsLoading
    })
  };

  goToHome = () => {
    const {history} = this.props;

    history.push("/");
  };

  setErrorMessage = (errorCode?: string) => {
    this.setState({
      errorCode: errorCode
    })
  };

  clearTableView = () => {
    this.setState( {
      billsKey: this.state.billsKey + 1
    })
  };

  render(): React.ReactNode {

    const {billsKey, bills, billsLoading, errorCode} = this.state;
    const {currentPatient, getMessage, onPatientRefresh} = this.props;

    return (
        <StyledAutomaticPaymentContainer>
          <FullScreenPageHeader headerMessage={getMessage("header.navigation.automaticPayment")}
                                buttonMessage={getMessage("back")}
                                onConfirm={() => this.goToHome()}/>

          <StyledAutomaticPayment>
            {errorCode && (
                <StyledError>
                  <StyledErrorMessage onDismiss={() => this.setErrorMessage()}>
                    {getMessage(`automaticPayment.error.${errorCode}`)}
                  </StyledErrorMessage>
                </StyledError>
            )}

            <AutomaticPaymentTableView
                key={billsKey}
                bills={bills}
                billsLoading={billsLoading}
                currentPatient={currentPatient}
                onPatientRefresh={onPatientRefresh}
                onFilterBills={this.onFilterBills}
                onBillsLoadingChange={this.onBillsLoadingChange}
                resetBills={this.clearTableView}
            />
          </StyledAutomaticPayment>
        </StyledAutomaticPaymentContainer>
    );
  }
}

export default withRouterWorkaround(withPatientContext(withMessages(AutomaticPaymentView)));
